import { Actions, Badge, NameCell, PhoneCell, SubduedCell,DateTimeCell } from "@";

// Truncating message-title cell — full text in `title` attr on hover.
const MessageTitleCell = ({ value }) => {
  if (!value) return <NameCell name={value} />;
  const truncated = value.length > 45 ? value.slice(0, 45) + "…" : value;
  return (
    <span
      title={value}
      className="font-semibold tracking-tight text-gray-900 dark:text-gray-100"
    >
      {truncated}
    </span>
  );
};

// Body preview — secondary text, truncated, full text on hover.
const MessagePreviewCell = ({ value }) => {
  if (!value) return <SubduedCell value={value} />;
  const truncated = value.length > 50 ? value.slice(0, 50) + "…" : value;
  return (
    <span
      title={value}
      className="text-sm text-gray-600 dark:text-gray-400"
    >
      {truncated}
    </span>
  );
};

export const TableActions = ({ row, show }) => {
  return <Actions notEdit notDelete row={row} show={(item) => show(item)} />;
};

// TanStack column defs
export const tableColumns = [
  {
    id: "messageTitle",
    header: "عنوان الرسالة",
    cell: ({ row }) => (
      <MessageTitleCell value={row.original.messageTitle} />
    ),
  },
  {
    id: "phoneNumber",
    header: "رقم الجوال",
    size: 100,
    cell: ({ row }) => <PhoneCell phone={row.original.phoneNumber} />,
  },
  {
    id: "description",
    header: "الرسالة",
    size: 200,
    cell: ({ row }) => (
      <MessagePreviewCell value={row.original.description} />
    ),
  },
  {
    id: "type",
    header: "النوع",
    size: 80,
    cell: ({ row }) => (
      <Badge
        title={row.original.type == 0 ? "اقتراح" : "شكوي"}
        color={row.original.type == 0 ? "default" : "dark"}
      />
    ),
  },
  {
    id: "createdAt",
    header: "التاريخ",
    size: 110,
    cell: ({ row }) => <DateTimeCell value={row.original.createdAt} />,
  },
  {
    id: "contactUsReplyStatus",
    header: "الحالة",
    size: 80,
    cell: ({ row }) => (
      <Badge
        title={!row.original.contactUsReplyStatus ? "تحت الدراسة" : "مغلقة"}
        color={!row.original.contactUsReplyStatus ? "green" : "red"}
      />
    ),
  },
];
